module.exports = "<div #dropdown class=\"nice-select custom-select1\" [ngClass]=\"{'light': useLightClass, 'disabled-select': disabled }\"  tabindex=\"0\" (click)=\"onMenuClick($event)\">\r\n    <span>{{selectedText}}</span>\r\n    <ul class=\"list\" style=\"max-height:200px\">\r\n        <li *ngFor=\" let item of values \" (click)=\"onValueChange($event, item) \" class='option' attr.value={{item.value}}>{{item.label}}</li>\r\n    </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/dropdown.component.html
// module id = ./src/app/shared/dropdown.component.html
// module chunks = main